import { graphql } from "../graphql";

export const GetPageBySlug = graphql(/* GraphQL */ `
  query GetPageBySlug(
    $locale: String
    $preview: Boolean = true
    $slug: String
  ) {
    pageCollection(
      locale: $locale
      preview: $preview
      where: { slug: $slug }
      limit: 1
    ) {
      items {
        ...PageContent
      }
    }
  }
`);
